// Environment-compatibility rule shared by the connection pickers (wizard +
// editor): a `null`/undefined connection environment means "any environment"
// and is always offered; a concrete environment is offered only when it
// matches the pipeline's environment exactly (DEV-6562). Backward compat: a
// connection that has never had an environment set (null) keeps appearing in
// every pipeline's pickers, unchanged from before this field existed.
export function isEnvCompatible(
  instanceEnv: string | null | undefined,
  pipelineEnv: string | null | undefined,
): boolean {
  return instanceEnv == null || instanceEnv === pipelineEnv;
}
